import { createApp } from 'vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import './styles/global.scss'

export function bootstrapPage(component) {
  loadFonts()

  createApp(component)
    .use(vuetify)
    .mount('#app')
}
